import React from "react";

import PropTypes from "prop-types";

import { Query } from "react-apollo";

import { SINGLE_EMPLOYEE_ACTIVE_STATUS_QUERY } from "../../graphql/Employees/Employees.graphql";

function EmployeeActive(props) {
  return (
    <Query {...props} query={SINGLE_EMPLOYEE_ACTIVE_STATUS_QUERY}>
      {payload => props.children(payload)}
    </Query>
  );
}

EmployeeActive.propTypes = {
  children: PropTypes.func
};

export default EmployeeActive;
